module.exports = __webpack_public_path__ + "static/img/visited.0f26ec99.png";